import VaffMedia from './VaffMedia.js';
import VaffMediaField from './VaffMediaField.js';
import VaffMediaUpload from './VaffMediaUpload.js';

export default {
	vaffMedia: VaffMedia,
	vaffMediaField: VaffMediaField,
	VaffMediaUpload: VaffMediaUpload,
};
